import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

type RemoveVoucherResponse = { data: { items: { cart: Cart } } };

export const removeVoucher = (): Promise<Cart> =>
    (axios.delete(`${API_URLS.CART}cancel-voucher`) as unknown as Promise<RemoveVoucherResponse>).then(
        (response) => response.data.items.cart
    );
